import React from "react";
import "./Home.css";

const Home = () => {
  return (
    <div>
      <h2>Welcome to H.E.A.R.T.</h2>
      <p>
        This page is still under construction. Here for PvE Whitelisting? Click
        on the settings tab on the left.
      </p>
    </div>
  );
};

export default Home;
